import { get, post, put, del } from 'utils/methods';

export function addNewCarrierApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/carrier`, data, headers);
}

export function editCarrierApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/carrier`, data, headers);
}

export function updateCarrierTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/carrier/translate`, data, headers);
}

export function addPropertyToCarrierApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/carrier/property`, data, headers);
}

export function deletePropertyToCarrierApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/carrier/property`, data, headers);
}

export function getCarriersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}carriers`, data, headers);
}
